import Tab from "components/Tab";
import RubyMethod2 from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ruby-set-send-feature-flags-to-true.mdx";
import NodeMethod2 from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-node-set-send-feature-flags-to-true.mdx";
import GoMethod2 from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-go-set-send-feature-flags-to-true.mdx";
import PythonMethod2 from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-python-set-send-feature-flags-to-true.mdx";
import PHPMethod2 from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-php-set-send-feature-flags-to-true.mdx";
import * as React from 'react';
export default {
  Tab,
  RubyMethod2,
  NodeMethod2,
  GoMethod2,
  PythonMethod2,
  PHPMethod2,
  React
};